import { render, staticRenderFns } from "./detail-staff-manager.vue?vue&type=template&id=b265e5c4"
import script from "./detail-staff-manager.vue?vue&type=script&lang=tsx"
export * from "./detail-staff-manager.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports